// Marquesina editorial lenta e infinita
export const Marquee = ({
  text = "Diseño que conecta e inspira",
  separator = "✦",
  className = "",
  testId,
}) => {
  const unit = (
    <span className="flex items-center whitespace-nowrap">
      {Array.from({ length: 6 }).map((_, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic">{text}</span>
          <span className="mx-8 md:mx-12 text-rosegold text-2xl md:text-3xl not-italic">{separator}</span>
        </span>
      ))}
    </span>
  );

  return (
    <div className={`relative w-full overflow-hidden ${className}`} data-testid={testId}>
      <div className="flex w-max animate-marquee">
        {unit}
        {unit}
      </div>
    </div>
  );
};

export default Marquee;
